import instance from "../../axios/axios-user";
import { API_PATHS } from "../api_paths";

const getPostImage = (id: string) =>
  instance(API_PATHS.posts.getPostImage + id);

export const IMAGES = {
  getPostImage,
};
